module.exports = __webpack_public_path__ + "static/media/darkBackButton.94e81a0e.svg";